export default [
  {
    alt: 'book jacket for  Hearing Voices-Dorothea Dix and the Asylum Movement',
    copy: `
    <p>Dorothea Lynde Dix, born to a dysfunctional nineteenth century family,
    was the least likely person to bring about major social change
    and alter the way the world thinks about people who hear voices.
    As she nears the end of her life, Dorothea recalls the many contradictions
    she has experienced.  She grew up in a log shack but dined at the White House,
    she never married but carried on a flirtation with a President and a Senator,
    and she addressed the legislatures of more than thirty states but never had the right to vote.</p>
    <p>As Dorothea remembers the triumphs and defeats in her fight to establish mental asylums
    to care for those who hear voices, she realizes her biggest struggle was coming to terms with her own childhood.</p>
    `,
    link: "https://www.amazon.com/Hearing-Voices-Dorothea-Asylum-Movement-ebook/dp/B07V2P254W/",
    image: 'hearingVoices.jpg',
    title: 'Hearing Voices-Dorothea Dix and the Asylum Movement'
  },
  {
    alt: 'book jacket for witch\'s voice',
    copy: `<p>In 1660 the fires of the Inquisition are raging throughout
            Europe but in England the laws, medicine, and theology have combined
            to light a fire of their own; the hunt for witches.<p/>
            <p><b>A Witch's Voice</b>, set in Essex, England, is the story of Rose Gilbert,
            only daughter of Henry Gilbert, a prosperous landowner. Her future inheritance
            has not escaped the notice of her nosy Puritan neighbor, Agnes March who has
            also noticed Rose's odd behavior; Rose hears voices. Rose seeks help from the
            Anglican cleric and physic John Wentworth who uses the latest medicine; astrology.
            When the stars and planets fail to cure her he recommends a pilgrimage to Geel,
            Belgium where, for nearly a thousand years, others who hear voices have journeyed
            in hopes of a miracle from Saint Dymphna. The stay in the unique town seems to help
            Rose and Henry believes she is cured.<p/>
            <p>On their return Agnes, aided by her Puritan cleric
            Profideous Thayer, have used the laws that outline proper procedure for discovering
            and prosecuting witches, to bring Rose to trial.<p/>`,
    link: "http://www.amazon.com/A-Witchs-Voice-Jane-Hartenstein-ebook/dp/B00P15JP64",
    image: 'awitchsvoice.jpg',
    title: 'A Witch\'s Voice'
  },
  {

    alt: 'book jacket for voices',
    copy: `<p>As the first Crusaders leave for the Holy Land, the struggle
 between temporal and religious factions pit bureaucrat Count Edouard
 against the wily Bishop Rupert. The situation comes to a head when the
 young Brother Henri in Rupert's monastery begins to hear voices telling
 him that he is the long deceased Saint Martin.<p/>
 <p>The solution is a "Ship of Fools" supposedly sailing to the Holy Land to
 join the Crusade. Thus begins a seemingly impossible journey through the
 inland waterways of Europe with Wilem, an alcoholic who sleeps in stables,
 young Ekkehart who hears voices on the wind, and Adele whose tall tales come
  directly from the voices she hears.<p/>
 <p>Guided by a Moor returning to a homeland he's never seen and a psychic attempting
 to escape the fires of the Inquisition, the erstwhile pilgrims encounter Eastern
 as well as Western laws, beliefs, and medicine, sailing a much greater distance
 than mere miles as their journey takes them from the dark night of superstition
 to the dawn of psychiatric treatment as they seek hospice in the same place others
 seek asylum and prosperity; Jerusalem.</p>`,
    link: "http://www.amazon.com/Voices-ebook/dp/B005H7LN7K",
    image: 'voices-cover.jpg',
    title: 'Voices'
  },
  {

    alt: 'book cover for Ancient City Stories',
    copy: `<p>Ancient City Stories celebrates the unique history of St. Augustine in the voices of those who lived it.  </p>
        <p> In the late 1600’s Señora Donna Isabella Cabrera provides a picture of 17th century life in the young colony and she is not above a bit of gossip or the latest scandal.</p>
        <p>1810 sees Scottish physician Dr. Thomas MacDonnell and his family witness the transfer of Florida from Spain to the United States as an epidemic of yellow fever threatens. </p>
        <p>Curative baths and pampering treatments are all the rage for the Gilded Age wealthy who winter in St. Augustine attended by staff that spend their days and their lives following society’s seasons and foibles.</p>
        `,
    link: "https://www.amazon.com/Ancient-City-Stories-Tales-Augustine/dp/B0CRVFZQTT",
    image: 'ancient-city-stories-main.png',
    subtitle: 'Tales of St Augustine',
    detailImage: 'ancient-city-stories.jpg',
    title: 'Ancient City Stories'
  },
  {

    alt: 'book cover for An Epidemic of Glory',
    copy: `<p> In 1559 Spain finds herself in possession of an immense uncharted land they call the East Indies. Spanish conquistadors, eager to find their fortune and a place in history, explore the new wilderness, unaware they are spreading European disease among the natives they call Indios</p>
        <p>Spain soon realizes she must colonize this new land to stave off the treats of other countries and so begins the historic journey of Don Tristan de Luna. Son of an old noble Spanish family, he is to lead the largest and most ambitious expedition Spain has ever launched and establish a settlement on Ochuse Bay, now known as Pensacola.</p>
        <p>Almost immediately Tristan de Luna’s colony is ravished by a hurricane then must struggle to fend off starvation but it is the legacy of disease and death left by the conquistadors that will determine the success or failure of the settlement and chart the course of Pensacola and La Florida’s history.</p>
        `,
    link: "https://a.co/d/2ZSRpgv",
    image: 'an-epidemic-of-glory.jpg',
    subtitle: 'La Florida\'s Lost Colony',
    newRelease: true,
    detailImage: 'an-epidemic-of-glory.jpg',
    title: 'An Epidemic of Glory',
  },
]

